import { ReactNode, useEffect } from 'react';
import { ToastContainer, toast, ToastContainerProps, TypeOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type TToastProps = ToastContainerProps & {
    show: boolean;
    screen: ReactNode | string;
    type?: TypeOptions;
};

export const Toast = ({ type = 'default', show, screen, ...toastProps }: TToastProps) => {
    useEffect(() => {
        if (!show) return;
        const id = setTimeout(() => {
            if (type === 'default') toast(screen, { ...toastProps });
            else toast[type](screen, { ...toastProps });
        }, 1);
        return () => clearTimeout(id);
    }, [screen, toastProps, show, type]);

    return (
        <ToastContainer
            className="toastify-container"
            position={'top-left'}
            autoClose={3000}
            newestOnTop
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            data-test-id="toast"
            progressStyle={{
                position: 'absolute',
                bottom: 0,
                left: '32px',
            }}
        />
    );
};
